/**
 * Minimal copy-to-clipboard helper. Phase X.3.4.
 *
 * Uses the async Clipboard API where available; falls back to a
 * textarea + execCommand for older browsers (Safari iOS < 13.4).
 */
export async function copyToClipboard(text: string): Promise<void> {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
}

/**
 * Rich-text copy (0161 intro email): writes BOTH flavors so Outlook pastes
 * the formatted block (text/html) while plain-text targets get the fallback
 * (text/plain). Where ClipboardItem is unavailable (older Safari/Firefox),
 * degrades to the plain-text copy above — the placeholders keep their
 * bracket form, so the email is still completable by hand.
 */
export async function copyRichToClipboard(html: string, text: string): Promise<void> {
  if (navigator.clipboard?.write && typeof ClipboardItem !== 'undefined') {
    await navigator.clipboard.write([
      new ClipboardItem({
        'text/html': new Blob([html], { type: 'text/html' }),
        'text/plain': new Blob([text], { type: 'text/plain' }),
      }),
    ]);
    return;
  }
  await copyToClipboard(text);
}
